import React, { useState } from 'react'
import IntegrationTopbar from './Topbar'
import GoogleSignIn from '../../../authentication/component/GoogleSignIn'
import AuthForm from './AuthForm'
import { useAppServices } from '../../../../hook/services'
import { useUserInfo } from '../../../../context/user'
import { useNavigate } from 'react-router-dom'
import localforage from 'localforage'

const IntegrationSignin = () => {
    const queryString = window.location.search;
    const account_id = new URLSearchParams(queryString).get("id");
    const service = useAppServices();
    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const updateUser = useUserInfo()[1];
    const saveActiveLocation = useUserInfo()[5];
    const navigate = useNavigate()
    const [formInputs, setFormInputs] = useState({
        email: "",
        password: "",
        type: "email",
    });

    const handleSubmit = async (e) => {
        setLoading(true)
        if (e && !e.email)
            e.preventDefault();
        const payload = {
            ...(e && e.email ? e : formInputs),
            user_type: "integration",
            ...(account_id ? { account_id } : {}),
        }
        const { response, error } = await service.auth.integrationAppLogin({ payload })
        if (error?.message) {
            setError(error?.message);
            setLoading(false);
            return;
        }

        if (response?.data) {
            const { token, ...user } = response.data;
            await localforage.setItem("token", token);
            await localforage.setItem("user", user);
            response?.brand && (await localforage.setItem("brand", response?.brand));
            response?.agency &&
                (await localforage.setItem("agency", response?.agency));
            saveActiveLocation(response?.activeLocation);
            updateUser(user);
            setLoading(false);
            navigate("/integration-app/");
        }


    }

    return (
        <div className='flex flex-col items-center justify-center h-screen'>
            <IntegrationTopbar account_id={account_id} />
            <div className='h-full flex flex-col items-center justify-center min-w-[450px]'>
                <h1 className="font-semibold text-2xl max-w-[450px] mt-[58px] text-center">Sign in to your account</h1>
                <GoogleSignIn
                    buttonText={"Sign in with Google"}
                    enabled
                    onSuccess={handleSubmit}
                    onUnavailable={setError}
                />
                <p className="relative border-b !border-[#D9D9D9] w-full my-6">
                    <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-4 text-[#B3B3B3] py-2 bg-white">
                        OR
                    </span>
                </p>
                <p className="mb-8">Enter your email below to Sign in</p>
                <AuthForm
                    formInputs={formInputs}
                    onChange={(e) => { setFormInputs({ ...formInputs, [e.target.name]: e.target.value }) }}
                    handleSubmit={handleSubmit}
                    loader={loading}
                    formType="signin"
                    error={error}
                />
            </div>
        </div >
    )
}

export default IntegrationSignin
